import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as actions from '../../../actions';
import template from './newStonePopup.rt';
import {AccessRights, PARTS} from './../../../schemas/accessRightsModel';

const filterSort = (filters) => {
  var validFilters = _.uniqWith(filters.filter(f => !_.isEmpty(f.value)), (a, b) => {
    return _.trim(a.value).toLowerCase() == _.trim(b.value).toLowerCase() 
        && _.trim(a.displayText).toLowerCase() == _.trim(b.displayText).toLowerCase();
  });
  validFilters.sort((a, b) => {
    let at = _.isEmpty(a.displayText) ? a.value : a.displayText
      , bt = _.isEmpty(b.displayText) ? b.value : b.displayText
      , av = _.trim(at).toLowerCase()
      , bv = _.trim(bt).toLowerCase();
    if(av < bv) {
      return -1;
    } else if(av > bv) {
      return 1;
    }
    return 0;
  });
  return validFilters;
}

function mapStateToProps(state) {
  const {filterGroups, selectedFilters} = state.stonesV2;
  
  let materialFilters = []
    , colorFilters = [];
  if(filterGroups && filterGroups.length > 0) {
    let stoneMaterialFilter = _.first(filterGroups.filter(f => f.name == "Stone Material")),
        stoneColorFilter    = _.first(filterGroups.filter(f => f.name == "Stone Color"));

    if(stoneMaterialFilter && stoneMaterialFilter.values)
      materialFilters = filterSort(stoneMaterialFilter.values);
    
    if(stoneColorFilter && stoneColorFilter.values)
      colorFilters = filterSort(stoneColorFilter.values);
  }

  return {
    materialFilters: materialFilters,
    colorFilters: colorFilters,
    selectedFilters,
    AR: AccessRights.get(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    close: () => dispatch(actions.newStone.showNewStonePopup(false)),
    save: (state) => dispatch(actions.newStone.saveNewStone(state)),
    update: (state) => dispatch(actions.newStone.updateStone(state)),
    createMaterialFilter: (filterName, quartz) => dispatch(actions.newStone.createMaterialFilter(filterName, quartz)),
    createColorFilter: (color, value) => dispatch(actions.newStone.createColorFilter(color, value)),
    showErrorBox: (title, text) => dispatch(actions.messageBox_Show(true, 'error', title, text)),
    showMessageBox: (title, text) => dispatch(actions.messageBox_Show(true, 'system', title, text)),
    showLoadingDialog: (show, title, text) => dispatch(actions.loadingDialog_show(show, title, text)),
    showImageUploadNotice: (preview) => dispatch(actions.newStone.showImageUploadNotice(preview))
  };
}

function filterExpandedComparator(a, b) {
  return (a == b.id && b.items && b.items.length > 0);
}

function filterIntersectionComparator(a, b) {
  if(a == b.id)
    return true;
  if(b.items && b.items.length > 0)
    return _.findIndex(b.items, (item) => { return a == item.id }) >= 0;
  return false;
}

class NewStonePopup extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      name: '',
      description: '',
      materialFilters: [],
      colorFilters: [],
      expanded: [],
      imageUrl: '',
      image: null,
      newMaterialFilterVisible: false,
      newColorFilterVisible: false,
      newMaterialFilterQuartz: false,
      newMaterialFilterValue: '',
      newColorFilterValue: null,
      newColorFilterName: '',
      warnings: [],
      selectedFilters: []
    }
    if(props.stone) {
      this.state.id = props.stone.id;
      this.state.name = props.stone.name;
      this.state.description = props.stone.description || "";
      this.state.selectedFilters = _.map(props.stone.filters, f => f.filterGroupValue_id);
      this.state.imageUrl = props.stone.imageUrl || "";
    }
  }
  render = template;

  handleSave = () => {
    if(this.state.id > 0)
      this.props.update(this.state);
    else
      this.props.save(this.state);
  }

  onDrop = (file) => {
    this.props.showLoadingDialog(true, "Loading Image...", "Scanning/Loading image, this should only take a moment...")
      .then(() => {
        var img = new Image();
        img.onload = () => {
          var height = img.height;
          var width = img.width;
          var warnings = [], errors = [];
          if(height - width !== 0) {
            warnings.push('Image height and width are not equal.  Stone images work best if they are square.');
          }
          if(height > 3840 || width > 3840) {
            warnings.push('Image dimensions are exceeding 3840 pixels in either height or width');
          }
          if(file[0].size > 4194304) {
            errors.push('Image size is exceeding 4MB in size.');
          }
          if(errors.length > 0) {
            this.props.showErrorBox('Unable to use Image', errors.join('<br />'));
          } else {
            this.props.showImageUploadNotice(file[0].preview).then(() => {
              this.setState({imageUrl: file[0].preview, image: file[0], warnings});
            }).catch(() => {
              this.setState({warnings: []});
            });
          }
        }
        if(file && file.length >= 1 && file[0].preview) {
          img.src = file[0].preview;
        } else {
          this.props.showErrorBox("Unable to use Image", "Unrecognized image format, please use a JPEG or PNG image.");
        }
      });
  }

  isChecked = (item) => {
    return (this.state.selectedFilters.indexOf(item.id) >= 0);
  }

  imageUploadStyles = () => {
    if(this.state.imageUrl.length > 0) {
      return {
        'backgroundImage': 'url(' + this.state.imageUrl + ')',
        'backgroundSize': 'cover',
        'backgroundPosition': 'center center',
        'backgroundRepeat': 'no-repeat',
        'width': '100%',
        'height': '100%',
        'borderRadius': '5%'
      };
    }
    return {
      'width': '100%',
      'height': '100%'
    };
  }

  imageUploadDropzoneStyles = () => {
    return {
      'height': '100%', 
      'width': '100%', 
      'border': 'none', 
      'overflow': 'hidden', 
      'borderRadius': '20px',
      'opacity' : this.state.imageUrl.length > 0 ? '0' : '1'
    };
  }

  handleItemClick = (item) => {
    let index = this.state.selectedFilters.indexOf(item.id),
      selectedFilters = this.state.selectedFilters;
    if(index >= 0) {
      selectedFilters.splice(index, 1);
    } else {
      selectedFilters.push(item.id);
    }

    this.setState({selectedFilters});
  }

  saveNewMaterialFilter = () => {
    this.props.createMaterialFilter(this.state.newMaterialFilterValue, this.state.newMaterialFilterQuartz)
      .then(response => {
        let selectedFilters = [...this.state.selectedFilters];
        selectedFilters.push(response.id);
        this.setState({selectedFilters, newMaterialFilterVisible: false});
      });
  }

  saveNewColorFilter = () => {
    this.props.createColorFilter(this.state.newColorFilterName, this.state.newColorFilterValue)
      .then(response => {
        let selectedFilters = [...this.state.selectedFilters];
        selectedFilters.push(response.id);
        this.setState({selectedFilters, newColorFilterVisible: false});
      });
  }

  showWarning = () => {
    this.props.showMessageBox("Image Warning", this.state.warnings.join('<br />'));
  }
}


const connector = connect(mapStateToProps, mapDispatchToProps);

const NewStonePopupContainer = connector(NewStonePopup);

export default NewStonePopupContainer;
